
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/potykacz",
      function () {
        return require("private-next-pages/potykacz.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/potykacz"])
      });
    }
  